import { Controller } from "@hotwired/stimulus"

// Controller para debounce de inputs con auto-submit
// Espera un tiempo después de que el usuario deja de escribir antes de enviar el formulario
// Preserva la posición del cursor después del submit
//
// Uso:
//   <form data-controller="debounce">
//     <input data-debounce-target="field"
//            data-action="input->debounce#trigger"
//            data-debounce-delay-value="500">
//   </form>
export default class extends Controller {
  static targets = ["field"]
  static values = {
    delay: { type: Number, default: 500 } // Delay en ms (por defecto 500ms)
  }

  connect() {
    this.timeout = null
    this.cursorPosition = null
    
    // Restaurar posición del cursor después de que Turbo actualice
    // Usar turbo:submit-end que se dispara cuando el submit termina
    this.boundRestoreCursor = this.restoreCursor.bind(this)
    this.element.addEventListener("turbo:submit-end", this.boundRestoreCursor)
  }

  disconnect() {
    this.clearTimeout()
    if (this.boundRestoreCursor) {
      this.element.removeEventListener("turbo:submit-end", this.boundRestoreCursor)
    }
  }

  trigger(event) {
    // Guardar la posición del cursor ANTES de hacer submit
    if (this.hasFieldTarget) {
      this.cursorPosition = this.fieldTarget.selectionStart
      console.log("📍 Cursor guardado en posición:", this.cursorPosition)
    }
    
    this.clearTimeout()
    
    // Programar el submit después del delay
    this.timeout = setTimeout(() => {
      this.submit()
    }, this.delayValue)
  }

  submit() {
    // Usar requestSubmit() para que dispare los eventos de submit correctamente
    // y sea compatible con Turbo
    this.element.requestSubmit()
  }

  restoreCursor(event) {
    // Restaurar la posición del cursor después de que el submit termine
    if (this.hasFieldTarget && this.cursorPosition !== null) {
      console.log("🔄 Restaurando cursor a posición:", this.cursorPosition)
      
      // Usar un pequeño delay para asegurar que el DOM se ha actualizado
      setTimeout(() => {
        this.fieldTarget.focus()
        this.fieldTarget.setSelectionRange(this.cursorPosition, this.cursorPosition)
        console.log("✅ Cursor restaurado")
      }, 10)
    }
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}
